module.exports = __webpack_public_path__ + "img/rob.89c83405.svg";